module.exports = __webpack_public_path__ + "static/media/stats-icon-3.ea4155b0.svg";